import { render, staticRenderFns } from "./rkbb.vue?vue&type=template&id=4ab4b1d7&scoped=true&"
import script from "./rkbb.vue?vue&type=script&lang=js&"
export * from "./rkbb.vue?vue&type=script&lang=js&"
import style0 from "./rkbb.vue?vue&type=style&index=0&id=4ab4b1d7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab4b1d7",
  null
  
)

export default component.exports